export default function userCan(permission, entity = null) {
  return (window.ENV?.CURRENT_USER_PERMISSIONS || []).includes(permission)
}
